// Edits that would be lost: the browser asks before a reload or a closed tab.
// (Moving to another page inside the app is not blocked: the forms that use this
// are dialogs, which ask themselves, or keep a Save bar in view.)
import { useEffect } from 'react'

export function useUnsavedWarning(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return
    const warn = (e: BeforeUnloadEvent) => e.preventDefault()
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [dirty])
}
